import Swiper from 'swiper/bundle'
import 'swiper/css/bundle'

new Swiper('.default-carousel', {
    slidesPerView: 1.25,
    spaceBetween: 24,
    loop: true,
    slidesOffsetBefore: 0,
    slidesOffsetAfter: 0,
    breakpoints: {
        768: {
            slidesPerView: 1.5,
            spaceBetween: 48,
        },
        1024: {
            slidesPerView: 2.25,
        },
        1280: {
            slidesPerView: 2.5,
            spaceBetween: 64,
        },
    },
    navigation: {
        prevEl: '.prev-slide',
        nextEl: '.next-slide',
    },
})

new Swiper('.image-carousel', {
    slidesPerView: 1.25,
    spaceBetween: 16,
    loop: true,
    centeredSlides: true,
    breakpoints: {
        768: {
            slidesPerView: 1.5,
        },
    },
    navigation: {
        prevEl: '.prev-slide',
        nextEl: '.next-slide',
    },
})
new Swiper('.infoCards', {
    slidesPerView: 1,
    spaceBetween: 0,
    loop: true,
    speed: 1000,
    centeredSlides: true,
    navigation: {
        prevEl: '.prev-infoCards',
        nextEl: '.next-infoCards',
    },
    pagination: {
        el: '.infoCards-pagination ul', // target the UL
        clickable: true,
        bulletElement: 'li', // 👈 important
        renderBullet: function (index, className) {
            return `<li class="${className} opacity-100! bg-cream-120! px-1! w-fit! [&.active]:bg-pink! h-auto! rounded-none! cursor-pointer! transition-all duration-500">
                        ${infoCardTitles[index]}
                    </li>`
        },
    },

    on: {
        init: function () {
            updateActiveClass(this)
        },
        slideChange: function () {
            updateActiveClass(this)
        },
    },
})
